import React from "react";
import CareerHeaderImage from "../../assets/images/career/part-of-team.png";

const AboutSection = () => {
  return (
    <>
      <section>
        <div className="max-container">
          <div className="padd-90">
            <div className="grid-auto-fit align-items-center">
              <div className="text-center">
                <img
                  src={CareerHeaderImage}
                  alt="Come be a part of the team that's making it happen"
                  className="img-fluid"
                />
              </div>

              <div>
                <h2 className="roboto-bold mb10 heading29px">
                  Come be a part of the team that's making it happen
                </h2>
                <p className="roboto-regular heading16px">
                  Together, we can turn our vision into reality and make a
                  positive impact in the world.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default AboutSection;
